import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["theme", "textStyle"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import styled from "styled-components";
import { fontWeight, textAlign, lineHeight, fontFamily, letterSpacing, fontSize, space, color } from 'styled-system';
import Box from '../Box';
import { minTextMargins, minLineHeight } from '../space';
import { pickDefaultTextColor, styleFromVariant } from '../theme';
import { important, useThemeDefaults, pipe, truncate } from '../utils';
import { mapScaledPropValue } from '../scales';
export var BaseText = useThemeDefaults(function () {
  return {
    as: 'p',
    textStyle: ['bodyViewSRegular', 'bodyRegular']
  };
}, styled(Box).withConfig({
  displayName: "Text__BaseText",
  componentId: "sc-4nqr4q-0"
})({
  textDecorationSkipInk: "auto"
}, pipe(fontFamily, important), pipe(fontWeight, important), pipe(fontSize, important), textAlign, pipe(lineHeight, important), pipe(letterSpacing, important)));
BaseText.propTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, Box.propTypes), fontFamily.propTypes), fontSize.propTypes), fontWeight.propTypes), lineHeight.propTypes), letterSpacing.propTypes);
BaseText.displayName = 'BaseText';
export var setDefaultTextColor = function setDefaultTextColor(_ref) {
  var theme = _ref.theme,
      textStyle = _ref.textStyle;
  return mapScaledPropValue(function (val) {
    return pickDefaultTextColor(styleFromVariant(val));
  }, textStyle || theme.copyTextStyle);
};

var setTruncationProps = function setTruncationProps(props) {
  return props.truncate ? truncate : {};
};

var Text = useThemeDefaults(function (_ref2) {
  var theme = _ref2.theme,
      textStyle = _ref2.textStyle,
      props = _objectWithoutProperties(_ref2, _excluded);

  return _objectSpread({
    color: setDefaultTextColor({
      theme: theme,
      textStyle: textStyle
    }),
    as: "p",
    textStyle: theme.copyTextStyle
  }, setTruncationProps(props));
}, styled(BaseText).withConfig({
  displayName: "Text",
  componentId: "sc-4nqr4q-1"
})(minTextMargins, space, color));
Text.propTypes = _objectSpread(_objectSpread({}, BaseText.propTypes), minTextMargins.propTypes);
Text.displayName = 'Text';
export var InlineText = useThemeDefaults(function () {
  return {
    as: 'p'
  };
}, styled(BaseText).withConfig({
  displayName: "Text__InlineText",
  componentId: "sc-4nqr4q-2"
})(minLineHeight, space, color));
InlineText.propTypes = _objectSpread(_objectSpread({}, BaseText.propTypes), minLineHeight.propTypes);
export default Text;